import React, { useMemo } from "react";
import { TableRow } from "./TableRow";
import styled from "styled-components/macro";

type TableBodyProps = {
  uniqueKey: string;
  data: any[];
  cells: any[];
  selectedRows: any[];
  handleRowClick: (row: any) => void;
  columns: number;
  onPointerOver?: (e: any, type: any) => void;
  onPointerOut?: (e: any, type: any) => void;
};

const TableBody: React.FC<TableBodyProps> = ({
  uniqueKey,
  data,
  cells,
  selectedRows,
  handleRowClick,
  columns,
}) => {
  const selectedRowKeys = useMemo(
    () => new Set(selectedRows.map((row) => row[uniqueKey])),
    [selectedRows, uniqueKey],
  );

  const isRowSelected = (row: any) => selectedRowKeys.has(row[uniqueKey]);

  return (
    <TableBodyContainer id="table-rows-container">
      {data?.map((row: any, index: number) => (
        <TableRow
          key={row[uniqueKey]}
          row={row}
          rowIndex={index}
          cells={cells}
          isSelected={isRowSelected(row)}
          onClick={() => handleRowClick(row)}
          columns={columns}
        />
      ))}
    </TableBodyContainer>
  );
};

export { TableBody };

const TableBodyContainer = styled.div`
  display: grid;
  grid-auto-rows: min-content;
  overflow-y: auto;
  border: #ffffff50 solid 1px;
  border-right: none;
  border-top: none;
  padding-top: 1rem;

  gap: 1rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
    background-color: #fffdfd21;
  }

  ::-webkit-scrollbar {
    width: 9px;
    background-color: #ffffff50;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #413a3a2b;
  }
`;
